<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 lg6>
				<v-menu
					ref="menu"
					v-model="menu"
					:close-on-content-click="false"
					:nudge-right="40"
					transition="scale-transition"
					offset-y
					full-width
					max-width="290px"
					min-width="290px">
					<template v-slot:activator="{ on }">
						<v-text-field
							:readonly="true"
							browser-autocomplete="off"
							v-model="value"
							:disabled="disabled"
							type="text"
							clearable
							prepend-icon="event"
							v-on="on"
							aria-label="calendar menu item"
						></v-text-field>
					</template>
					<v-date-picker :first-day-of-week="1"
						v-model="value" no-title scrollable @input="menu = false" locale="pl-PL"></v-date-picker>
				</v-menu>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	import {abstractField} from "vue-form-generator";

	export default {

		name: "customCalendar",

		mixins: [abstractField],

		data() {
			return {
				menu: false,
				modal: false,
			};
		},
	};
</script>

<style scoped>

</style>
